import { FormProvider } from 'core/states';
import { IProspectQuoteForm } from 'quotes/types';

import { ProspectQuoteUpsertFormFields } from './ProspectQuoteUpsertFormFields';
import { prospectQuoteSchema } from './schema';

const DEFAULT_VALUES: IProspectQuoteForm = {
  companyName: '',
  email: '',
  firstName: '',
  lastName: '',
};

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ProspectQuoteUpsert = ({ isOpen, onClose }: IProps) => (
  <FormProvider schema={prospectQuoteSchema()} defaultValues={DEFAULT_VALUES}>
    <ProspectQuoteUpsertFormFields
      defaultValues={DEFAULT_VALUES}
      isOpen={isOpen}
      onClose={onClose}
    />
  </FormProvider>
);
